"use strict";

module.exports = {
  0: 'Custom',
  300: 'Last 5 minutes',
  900: 'Last 15 minutes',
  3600: 'Last hour',
  10800: 'Last 3 hours',
  21600: 'Last 6 hours',
  86400: 'Last day',
  100800: 'Last day + 4 hours',
  172800: 'Last 2 days',
  187200: 'Last 2 days + 4 hours',
  259200: 'Last 3 days',
  604800: 'Last week',
  1209600: 'Last 2 weeks',
  2592000: 'Last 30 days',
  1: 'This month',
  2: 'Last month'
};